import { FCC } from '~/core/@types/global'
import { cn } from '~/core/ui/utils'

const LPContainer: FCC<{ className?: string }> = ({
  children,
  className = ''
}) => {
  return (
    <div
      className={cn(
        'm-auto max-w-[1266px] px-4 tablet:px-6 desktop:px-0',
        className
      )}>
      {children}
    </div>
  )
}

export default LPContainer
